export default {
  name: 'PauseInCircleIcon',
  props: {
    width: {
      type: Number,
      default: 17
    },
    height: {
      type: Number,
      default: 17
    },
    color: {
      type: String,
      default: '#669EFF'
    }
  }
};